import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import * as Models from '../../models/models-index';
import { throwError, Observable } from 'rxjs';

@Injectable()
export class ResourceService {
  private readonly anonymousHttp: HttpClient;

  constructor(
    private http: HttpClient,
    httpBackend: HttpBackend) {
    // Bypass interceptors (Authorization header) when hitting signed blob URLs.
    this.anonymousHttp = new HttpClient(httpBackend);
  }

  getResources(): Observable<Models.FilesInSectionsModel[]> {
    return this.http.get<Models.FilesInSectionsModel[]>(
      environment.baseV5ApiUri + '/content/filelist',
    );
  }

  downloadResourceFile(resourceUri: string): Observable<Blob> {
    if (!resourceUri) {
      return throwError(() => 'Resource URI is required.');
    }

    return this.anonymousHttp.get(resourceUri, { responseType: 'blob' });
  }
}
